export default "__VITE_ASSET__JwjelEF0__"